import { createAction } from '@reduxjs/toolkit'

export const addUsdPriceForToken = createAction<{ address: string; usdPrice: number }>('prices/addUsdPriceForToken')
export const addUsdPriceForTokens = createAction<{ fetchResult: Record<string, number> }>('prices/addUsdPriceForTokens')
export const reset = createAction('prices/reset')
export const clear = createAction('prices/clear')
